<span
  *ngFor="let survey of surveys"
  matTooltip="{{ survey.title }}"
>
  {{ survey.code }}
</span>
